import React, { useRef } from 'react';
import SearchInput from './SearchInput';
import ResultsPopper from './ResultsPopper';

const BetaSearchBarRoot = (props) => {
  const searchInputRef = useRef();
  return (
    <React.Fragment>
      <SearchInput
        {...props}
        inputRef={searchInputRef}
      />
      <ResultsPopper
        searchInputRef={searchInputRef}
      />
    </React.Fragment>
  );
};

export default BetaSearchBarRoot;
